var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"twitter-widget"},[_c('p',[_vm._v("お問い合わせはDMリプライお気軽にどうぞ〜")]),_vm._v(" "),_c('v-timeline',{attrs:{"id":_vm.twitterId,"source-type":'profile',"options":{ 'height': _vm.twitterHeight }}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05edc655","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/TwitterTimeLine.vue
// module id = null
// module chunks = 